// extracted by mini-css-extract-plugin
export default {"wrapper":"landing_wrapper__edD4k","body":"landing_body__K2HGd","img":"landing_img__cVvIh","head":"landing_head__dfHNF","login":"landing_login__WZTWo"};